/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: User
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 13Jan2022 craig File created.
 \******************************************************************************/
import React, {useMemo, useState} from "react";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {GSContext} from "../../../../context/context";
import "../Forms.css";
import {useNavigate, useParams} from "react-router-dom";
import {IUser} from "../../../../models/user/IUser";
import {getDataGet, getDataPost} from "../../../../models/data/Data";
import * as Yup from 'yup';
import {Formik, ErrorMessage} from 'formik';

export const User: React.FC = (props) => {

    const {userID} = useParams();

    const [user, setUser] = useState<IUser>({
        UserID: -1,
        //Name: "",
        FirstName: "",
        LastName: "",
        EmailAddress: "",
        //Username: "",
        PhoneNumber: "",
        Title: "",
        Organization: "",
        RoleID: -1,
        Role: {
            RoleID: -1,
            Role: "Guest"
        },
        Attested: false,
        Authenticated: false
    });

    const [sessionUser] = React.useContext(GSContext);
    const [disabled, setDisabled] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("Add User")
    const [selectedRole] = useState("2");

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    const schema = Yup.object().shape({
        firstname: Yup.string().required(),
        lastname: Yup.string().required(),
        emailaddress: Yup.string().required().email(),
        //phonenumber: Yup.string().required().matches(phoneRegExp, 'Phone number is not valid'),
        title: Yup.string().required(),
        organization: Yup.string().required(),
    });


    const navigate = useNavigate();


    const roleList = [
        {key: "2", role: "Reviewer"},
        {key: "3", role: "Gold Standard Admin"},
    ];


    useMemo(() => {
        if (userID !== undefined) {
            const usersURL = process.env.REACT_APP_API_URL + "/api/admin/user/" + userID;

            getDataGet(usersURL).then(response => {
                setUser(response);
                //setName(response.Name);
/*                setFirstName(response.FirstName);
                setLastName(response.LastName);
                setEmailAddress(response.EmailAddress);
                setPhoneNumber(response.PhoneNUmber);
                setDisabled(true);
                setButtonLabel("Update User");
                setSelectedRole(response.RoleID);
                setTitle(response.Title);
                setOrganization(response.Organization);*/
                //setSelectedRole(user.Role.Id)
            })
        }
    }, [])

    /*
        const handleRoleSelect = (eventKey: any, event: Object) => {
            const role = roleList?.find(e => e.key === eventKey)?.role;
            if (role !== undefined) {
                setSelectedRole(eventKey);
                setSelectedRoleName(role);
            }

        }*/

    const buildRoleList = () => {
        let optionTemplate = roleList.map(v => (
            <option value={v.key}>{v.role}</option>
        ));

        if (sessionUser.Role.Id === 4) {
            //roleList.push({key: "4", role: "System Admin"})
            optionTemplate.push(<option key={"4"}>System Admin</option>);
        }
        return optionTemplate;
    }

    const buildForm = () => {
        let userUpdateURL = process.env.REACT_APP_API_URL + "/api/admin/";
        if (userID !== undefined) {
            userUpdateURL += "updateuser/" + userID;
        } else {
            userUpdateURL += "newuser";
        }

        return (
            <Formik
                enableReinitialize={true}
                validationSchema={schema}
                onSubmit={(values) => {
                    const data = `${encodeURIComponent("emailaddress")}=${encodeURIComponent(values.emailaddress)}
                        &${encodeURIComponent("firstname")}=${encodeURIComponent(values.firstname)}
                        &${encodeURIComponent("lastname")}=${encodeURIComponent(values.lastname)}
                        &${encodeURIComponent("phonenumber")}=${encodeURIComponent(values.phonenumber)}
                        &${encodeURIComponent("title")}=${encodeURIComponent(values.title)}
                        &${encodeURIComponent("organization")}=${encodeURIComponent(values.organization)}
                        &${encodeURIComponent("role")}=${encodeURIComponent(values.role)}`;
                    getDataPost(userUpdateURL, data).then(response => {
                        navigate("/admin/users");
                    })
                }}
                initialValues={{
                    firstname: user.FirstName ?? '',
                    lastname: user.LastName ?? '',
                    emailaddress: user.EmailAddress ?? '',
                    phonenumber: user.PhoneNumber ?? '',
                    title: user.Title ?? '',
                    organization: user.Organization ?? '',
                    role: selectedRole,
                }}
                validateOnChange={false}
                validateOnBlur={false}>
                {({
                      handleSubmit,
                      handleChange,
                      resetForm,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                      isSubmitting,
                  }) => (
                    <Form className="form-layout" onSubmit={handleSubmit} noValidate={true}>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="firstname">
                                <Form.Label>First Name *</Form.Label>
                                <Form.Control required
                                              name={"firstname"}
                                              className="text-mid-width"
                                              type="text"
                                              placeholder="Enter first name"
                                              value={values.firstname}
                                              isValid={touched.firstname && !errors.firstname}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter first name.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a first name
                                </Form.Control.Feedback>
                                <ErrorMessage name={"firstname"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="lastname">
                                <Form.Label>Last Name *</Form.Label>
                                <Form.Control required
                                              name={"lastname"}
                                              className="text-mid-width"
                                              type="text"
                                              value={values.lastname}
                                              placeholder="Enter last name"
                                              isValid={touched.lastname && !errors.lastname}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter last name.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a last name
                                </Form.Control.Feedback>
                                <ErrorMessage name={"lastname"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="emailaddress">
                                <Form.Label>Email *</Form.Label>
                                <Form.Control required
                                              name={"emailaddress"}
                                              className="text-mid-width"
                                              type="email"
                                              placeholder="Enter email"
                                              value={values.emailaddress}
                                              disabled={disabled}
                                              isValid={touched.emailaddress && !errors.emailaddress}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter users email address.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid email address
                                </Form.Control.Feedback>
                                <ErrorMessage name={"emailaddress"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="phonenumber">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control required
                                              name={"phonenumber"}
                                              className="text-mid-width"
                                              type="text"
                                              placeholder="Enter phone number"
                                              value={values.phonenumber}
                                              isValid={touched.phonenumber && !errors.phonenumber}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter users phone number.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid phone number
                                </Form.Control.Feedback>
                                <ErrorMessage name={"phonenumber"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="title">
                                <Form.Label>Title *</Form.Label>
                                <Form.Control required
                                              name={"title"}
                                              className="text-mid-width"
                                              type="text"
                                              value={values.title}
                                              placeholder="Enter title"
                                              isValid={touched.title && !errors.title}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter users title.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a title for the user
                                </Form.Control.Feedback>
                                <ErrorMessage name={"title"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="organization">
                                <Form.Label>Organization *</Form.Label>
                                <Form.Control required
                                              name={"organization"}
                                              className="text-mid-width"
                                              type="text"
                                              value={values.organization}
                                              placeholder="Enter organization"
                                              isValid={touched.organization && !errors.organization}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter users organization.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide an organization for the user
                                </Form.Control.Feedback>
                                <ErrorMessage name={"organization"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} className="col-left" controlId="formUserRole">
                                <Form.Label>Select Role *</Form.Label>
                                <Form.Control as={"select"}
                                              name={"role"}
                                              required
                                              className="text-mid-width"
                                              value={values.role}
                                              isValid={touched.role && !errors.role}
                                              onChange={handleChange}>
                                    {buildRoleList()}
                                </Form.Control>

                            </Form.Group>
                        </Row>
                        <Button variant="primary" className="btn-submit" type="submit">
                            {buttonLabel}
                        </Button>
                    </Form>
                )}
            </Formik>
        )
    }

    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1 className="page-title">Add New User</h1>
                </Col>
            </Row>
            {buildForm()}
        </Container>
    );
}